import React from 'react';
import { FiSmartphone, FiBarChart2, FiLayers, FiSettings, FiZap, FiShield } from 'react-icons/fi';
import './Features.css';

const FeatureCard = ({ icon, title, description, index }) => {
  return (
    <div 
      className="feature-card" 
      data-aos="fade-up" 
      data-aos-delay={index * 100}
    >
      <div className="feature-icon-wrapper">
        <div className="feature-icon">{icon}</div>
      </div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
      <div className="feature-card-glow"></div>
    </div>
  );
};

const Features = () => {
  const features = [
    {
      icon: <FiLayers size={28} />,
      title: "Content Management",
      description: "Create, schedule, and manage your stories with our intuitive content management system."
    },
    {
      icon: <FiSmartphone size={28} />,
      title: "Native Integration",
      description: "Seamlessly integrate stories into your mobile app with our easy-to-use SDK for iOS and Android."
    },
    {
      icon: <FiBarChart2 size={28} />,
      title: "Analytics Dashboard",
      description: "Track user engagement with comprehensive analytics and insights to optimize your content."
    },
    {
      icon: <FiSettings size={28} />,
      title: "Customizable UI",
      description: "Tailor the look and feel of your stories to match your brand identity and app design."
    },
    {
      icon: <FiZap size={28} />,
      title: "Performance Optimized",
      description: "Built for speed and reliability, ensuring smooth playback and minimal impact on app performance."
    },
    {
      icon: <FiShield size={28} />,
      title: "Secure & Reliable",
      description: "Enterprise-grade security and reliability for your content and user data."
    }
  ];

  return (
    <section id="features" className="features">
      <div className="features-container">
        <div className="features-header">
          <h2 className="section-title" data-aos="fade-up">
            <span className="gradient-text">Powerful</span> Features
          </h2>
          <p className="section-description" data-aos="fade-up" data-aos-delay="100">
            Everything you need to create engaging stories for your mobile app users
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              index={index}
            />
          ))}
        </div>
        
        <div className="features-cta" data-aos="fade-up">
          <div className="cta-card glass">
            <div className="cta-content">
              <h3>Ready to boost your app engagement?</h3>
              <p>Join thousands of apps already using StoryCape</p>
            </div>
            <a href="#pricing" className="btn btn-primary">
              View Pricing
            </a>
          </div>
        </div>
      </div>
      
      <div className="features-shapes">
        <div className="feature-shape feature-shape-1"></div>
        <div className="feature-shape feature-shape-2"></div>
      </div>
    </section>
  );
};

export default Features;